import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'smr-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnChanges {

  constructor() { }

  private _lista: Array<any> | Observable<any>;
  @Input('pageSizeInput') pageSizeInput: any;
  @Input('pagesInput') pagesInput: any;
  @Input('pageStartInput') pageStartInput: any;
  @Input('length') length: number;
  @Output() pasarItems = new EventEmitter();

  filteredItems: any; /*Array*/
  pages = 3;
  pageSize = 12;
  pageNumber = 0;
  currentIndex = 1;
  items: any; /*Array*/
  pagesIndex: Array<number>;
  pageStart = 1;
  inputName: number;
  lengthLocal: number;
  async = false;

  first() {

    if (this.pageSizeInput) {
      this.pageSize = this.pageSizeInput;
    } else {
      this.pageSize = 12;
    }
    if (this.pagesInput) {
      this.pages = this.pagesInput;
    } else {
      this.pages = 3;
    }
    if (this.pageStartInput) {
      this.currentIndex = this.pageStart;
      this.pageNumber = this.pageStart - 1;
    } else {
      this.pageStart = 1;
      this.pageNumber = 0;
      this.currentIndex = 1;
    }
    if (!this.length) {
      this.lengthLocal = this.filteredItems.length;
    } else {
      this.lengthLocal = this.length;
    }
  }

  ngOnChanges() {
    if (this.lista instanceof Observable) {
      this.lista.subscribe(res => {
        this.lista = res;
        this.both();
      });
    } else {
      this.both();
    }
  }

  both() {
    if (this.lista) {
      this.filteredItems = this.lista;
    } else {
      this.filteredItems = [];
    }
    this.first();
    this.init();
    this.getListaObjetos();
  }


  init() {
    this.pageNumber = parseInt('' + (this.lengthLocal / this.pageSize), 0);
    if (this.lengthLocal % this.pageSize !== 0) {
      this.pageNumber++;
    }

    if (this.pageNumber < this.pages) {
      this.pages = this.pageNumber;
    }
    this.refreshItems();
  }
  getListaObjetos() {
    this.filteredItems = [];
    if (this.lista !== []) {
      this.filteredItems = this.lista;
    } else {
      this.filteredItems = [];
    }
    this.init();
  }
  fillArray(): any {
    const obj = new Array();
    for (let index = this.pageStart; index < this.pageStart + this.pages; index++) {
      obj.push(index);
    }
    return obj;
  }
  refreshItems() {
    if (this.lista) {
      this.items = this.filteredItems.slice((this.currentIndex - 1) * this.pageSize, (this.currentIndex) * this.pageSize);
    } else {
      this.items = [];
    }
    this.pagesIndex = this.fillArray();
    this.pasarItems.emit ({items: this.items ,  error : false, min: (this.pageSize * (this.currentIndex - 1)) + 1,
       max: this.pageSize * this.currentIndex });
  }
  prevPage() {
    if (this.currentIndex > 1) {
      this.currentIndex--;
    }
    if (this.currentIndex < this.pageStart) {
      this.pageStart = this.currentIndex;
    }
    this.refreshItems();
  }
  nextPage() {
    if (this.currentIndex < this.pageNumber) {
      this.currentIndex++;
    }
    if (this.currentIndex >= (this.pageStart + this.pages)) {
      this.pageStart = this.currentIndex - this.pages + 1;
    }

    this.refreshItems();
  }
  setPage(index: number) {
    this.currentIndex = index;
    this.refreshItems();
  }





  public get lista(): Array<any> | Observable<any>  { return this._lista; }
  @Input()
  public set lista(value: Array<any> | Observable<any> ) { this._lista = value; }


}
